const fonts = {
  Circular: '@import url(https://fonts.localsearch.com.au/Circular/style.css);',
  'Localsearch-Icon-Font':
    '@import url(https://fonts.localsearch.com.au/Localsearch-Icon-Font/style.css);',
  'Material-Design-Iconic-Font':
    '@import url(https://cdnjs.cloudflare.com/ajax/libs/material-design-iconic-font/2.2.0/css/material-design-iconic-font.min.css);',
  Roboto: '@import url(https://fonts.googleapis.com/css?family=Roboto);',
};

export default fonts;
